import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Check, Link2, MessageSquare, Monitor, Sparkles } from 'lucide-react';
import { Reveal } from '../Reveal';
import { TalabChapterFrame, TalabLockup } from './TalabChapterFrame';
import { NOVA_PRODUCTS } from '../../../data/talabProducts';
const EASE = [0.23, 1, 0.32, 1] as const;
const HERO_PICKS = [NOVA_PRODUCTS[4], NOVA_PRODUCTS[0]];
function StorefrontHero() {
  return <div className="overflow-hidden rounded-2xl border border-slate-900/[0.08] bg-white shadow-[0_34px_74px_-32px_rgba(15,23,42,0.38)]" data-id="element-855" data-mp="2ij0fxs1g0bix">
      <div className="flex items-center justify-between border-b border-slate-900/[0.06] px-[22px] py-[13px]" data-id="element-856" data-mp="29ivj2btvkvj0">
        <div className="flex items-center gap-[14px]" data-id="element-857" data-mp="24k11fd7n9d0h">
          <span className="text-[13px] font-semibold tracking-[0.26em] text-slate-900" data-id="element-858" data-mp="24jixdueqpui0">
            TALAB
          </span>
          <span className="h-[12px] w-px bg-slate-200" data-id="element-859" data-mp="y1cbk799i6en" />
          <span className="text-[11.5px] font-light text-slate-500" data-id="element-860" data-mp="t3uat45eexhq">
            Nova Sportswear · Conversational storefront
          </span>
        </div>
        <span className="rounded-full bg-slate-100 px-[10px] py-[4px] text-[9.5px] font-medium text-slate-500" data-id="element-861" data-mp="teugx66v6mne">
          talab.ai/novasport
        </span>
      </div>

      <div className="flex gap-[22px] px-[22px] py-[18px]" data-id="element-862" data-mp="fetalb7tyn0j">
        {/* Conversation */}
        <div className="w-[352px]" data-id="element-863" data-mp="kcl76ijf6xb2">
          <motion.div initial={{
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: EASE,
          delay: 0.26
        }} className="flex justify-end" data-id="element-864" data-mp="5p9v8fjbtbaf">
            <span className="max-w-[86%] rounded-2xl rounded-br-md bg-slate-100 px-[14px] py-[10px] text-[13px] leading-[1.45] text-slate-800" data-id="element-865" data-mp="3sur3p4zy892j">
              I need something comfortable for daily running.
            </span>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease: EASE,
          delay: 0.4
        }} className="mt-[12px] flex items-start gap-[9px]" data-id="element-866" data-mp="3ixuzvckzwb4b">
            <span className="mt-[2px] grid h-[22px] w-[22px] flex-shrink-0 place-items-center rounded-full bg-vexu/12" data-id="element-867" data-mp="2zz9mjgxvmkc0">
              <Sparkles className="h-[11px] w-[11px] text-vexu-700" data-id="element-868" data-mp="2v1848y89yp1l" />
            </span>
            <span className="rounded-2xl rounded-bl-md border border-vexu/25 bg-vexu/[0.06] px-[14px] py-[10px] text-[13px] leading-[1.45] text-slate-800" data-id="element-869" data-mp="2q2ev1i00tk78">
              These two are built for daily comfort. The Studio Daily is softer
              underfoot; the Aero Pace 5 holds up better on longer runs.
            </span>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.3,
          ease: EASE,
          delay: 0.72
        }} className="mt-[14px] flex items-center gap-[9px] rounded-full border border-slate-900/[0.08] bg-slate-50 px-[14px] py-[9px]" data-id="element-870" data-mp="38rv62z9c0v1w">
            <span className="h-[5px] w-[5px] rounded-full bg-vexu" data-id="element-871" data-mp="cuxdcqf2n4ka" />
            <span className="text-[11px] text-slate-400" data-id="element-872" data-mp="cskmfnrc5jv3">
              Which is better for flat feet?
            </span>
          </motion.div>
        </div>

        {/* Products */}
        <div className="grid flex-1 grid-cols-2 gap-[14px]" data-id="element-873" data-mp="mr8npav3pkc3">
          {HERO_PICKS.map((product, index) => <motion.div key={product.id} initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.32,
          ease: EASE,
          delay: 0.5 + index * 0.1
        }} className="overflow-hidden rounded-xl border border-slate-900/[0.07] bg-white" data-id="element-874" data-mp="rlmpbv0cwnp7" data-mpi={index}>
              <img src={product.image} alt={product.name} className="h-[136px] w-full object-cover" data-id="element-875" data-mp="1agbg9dr9wxld" />
              <div className="px-[13px] pb-[13px] pt-[10px]" data-id="element-876" data-mp="3cau1asjw6x10">
                <div className="text-[13px] font-semibold tracking-[-0.01em] text-slate-900" data-id="element-877" data-mp="16l8epftc8atv">
                  {product.name}
                </div>
                <div className="mt-[3px] flex items-center justify-between" data-id="element-878" data-mp="11lvt0ye7d9sv">
                  <span className="text-[12px] font-medium text-slate-500" data-id="element-879" data-mp="1fl58twyhy1wb">
                    {product.price}
                  </span>
                  <span className="text-[9.5px] font-semibold uppercase tracking-[0.12em] text-vexu-700" data-id="element-880" data-mp="1bigz7n1ykqya">
                    {index === 0 ? 'Softest' : 'All-round'}
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </div>;
}
function MerchantStrip() {
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.3,
    ease: EASE,
    delay: 0.8
  }} className="flex items-center gap-[18px] rounded-2xl border border-slate-900/[0.07] bg-white px-[20px] py-[14px] shadow-[0_1px_2px_rgba(15,23,42,0.04)]" data-id="element-881" data-mp="rw2hfxe28uom">
      <span className="rounded-2xl rounded-br-md bg-slate-100 px-[13px] py-[9px] text-[12px] text-slate-700" data-id="element-882" data-mp="3m5uaod15d2z2">
        “Add our new running collection.”
      </span>
      <ArrowRight className="h-[14px] w-[14px] flex-shrink-0 text-slate-300" data-id="element-883" data-mp="3c8y103ziiasx" />
      <span className="flex items-center gap-[8px] rounded-full border border-vexu/30 bg-vexu/[0.07] px-[13px] py-[7px] text-[12px] font-medium text-vexu-700" data-id="element-884" data-mp="3c6v0ur4nb1ah">
        <Check className="h-[12px] w-[12px]" data-id="element-885" data-mp="8tah7jqb5c0t" />
        12 products added
      </span>
      <div className="flex gap-[7px]" data-id="element-886" data-mp="drbvlrcsgn5y">
        {NOVA_PRODUCTS.slice(0, 4).map((product, index) => <motion.img key={product.id} src={product.image} alt={product.name} initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.28,
        ease: EASE,
        delay: 0.92 + index * 0.07
      }} className="h-[42px] w-[42px] rounded-lg object-cover ring-1 ring-slate-900/[0.06]" data-id="element-887" data-mp="3uy5pt2qt93zq" data-mpi={index} />)}
      </div>
      <span className="ml-auto max-w-[212px] text-right text-[11.5px] font-light leading-[1.5] text-slate-500" data-id="element-888" data-mp="q0rudmnmsaeb">
        Manage your catalogue by simply talking to AI.
      </span>
    </motion.div>;
}
const CONTEXTS = [{
  name: 'Private Link',
  detail: 'talab.ai/novasport',
  icon: Link2
}, {
  name: 'Website',
  detail: 'Built into novasport.com',
  icon: Monitor
}, {
  name: 'Embedded Widget',
  detail: 'Added to an existing site',
  icon: MessageSquare
}];
function ContextMock({
  index
}: {
  index: number;
}) {
  const product = NOVA_PRODUCTS[index];
  return <div className="w-[152px] flex-shrink-0 overflow-hidden rounded-lg border border-slate-900/[0.07] bg-white" data-id="element-889" data-mp="3tijw3srkk8pp">
      <div className="flex items-center gap-[4px] border-b border-slate-900/[0.05] bg-slate-50 px-[7px] py-[4px]" data-id="element-890" data-mp="1wop2h0r3cs4t">
        <span className="h-[3.5px] w-[3.5px] rounded-full bg-slate-300" data-id="element-891" data-mp="1rr6pmz9ydsrj" />
        <span className="h-[3.5px] w-[3.5px] rounded-full bg-slate-300" data-id="element-892" data-mp="1zay3gcf9zbzl" />
        <span className="ml-[3px] truncate text-[6.5px] text-slate-400" data-id="element-893" data-mp="248zmwygm5dbl">
          {index === 0 ? 'talab.ai/novasport' : 'novasport.com'}
        </span>
      </div>

      <div className="relative h-[76px]" data-id="element-894" data-mp="290rcp6ry3f0o">
        {index === 0 && <div className="flex h-full gap-[6px] p-[7px]" data-id="element-895" data-mp="2dy13oquzfyqm">
            <img src={product.image} alt="" className="h-full w-[54px] rounded-md object-cover" data-id="element-896" data-mp="1gbbvfz9ospwb" />
            <div className="flex flex-1 flex-col justify-center gap-[5px]" data-id="element-897" data-mp="1lax2yy2xa6kn">
              <span className="rounded-md bg-vexu/10 px-[6px] py-[3px] text-[6.5px] font-medium text-vexu-700" data-id="element-898" data-mp="1q8ggtwvpkhc2">
                What fits my run?
              </span>
              <span className="h-[4px] w-full rounded-full bg-slate-100" data-id="element-899" data-mp="31on6a2m7wqt8" />
              <span className="h-[4px] w-[70%] rounded-full bg-slate-100" data-id="element-900" data-mp="31qr9eicallsg" />
            </div>
          </div>}

        {index === 1 && <div className="h-full" data-id="element-901" data-mp="3rr0on1nawopn">
            <img src={NOVA_PRODUCTS[3].image} alt="" className="h-[42px] w-full object-cover" data-id="element-902" data-mp="3rsbur847y8jx" />
            <div className="flex items-center gap-[5px] px-[7px] py-[6px]" data-id="element-903" data-mp="5bxunuw5ex8b">
              <span className="flex-1 rounded-full border border-vexu/30 bg-vexu/[0.06] px-[7px] py-[3px] text-[6.5px] text-vexu-700" data-id="element-904" data-mp="5e0u15j6y2pp">
                Ask about this product
              </span>
            </div>
          </div>}

        {index === 2 && <>
            <div className="space-y-[5px] p-[7px] opacity-70" data-id="element-905" data-mp="ab0un0x9ud9f">
              <span className="block h-[4px] w-[56%] rounded-full bg-slate-200" data-id="element-906" data-mp="oa0l8e4ch288" />
              <div className="flex gap-[4px]" data-id="element-907" data-mp="jbh18j9ba0ii">
                <img src={NOVA_PRODUCTS[1].image} alt="" className="h-[34px] w-[38px] rounded object-cover" data-id="element-908" data-mp="jcs0c5rtak3a" />
                <img src={NOVA_PRODUCTS[2].image} alt="" className="h-[34px] w-[38px] rounded object-cover" data-id="element-909" data-mp="2l4n8ibev06gr" />
              </div>
            </div>
            <span className="absolute bottom-[6px] right-[6px] flex items-center gap-[4px] rounded-full bg-vexu px-[7px] py-[4px] text-[6.5px] font-semibold text-white shadow-[0_6px_14px_-6px_rgba(0,200,83,0.9)]" data-id="element-910" data-mp="15jmdlv50om1b">
              <MessageSquare className="h-[7px] w-[7px]" data-id="element-911" data-mp="vsi255ejvjb8" />
              Ask Talab
            </span>
          </>}
      </div>
    </div>;
}
interface TalabMeetSlideProps {
  onExit: () => void;
}
export function TalabMeetSlide({
  onExit
}: TalabMeetSlideProps) {
  return <TalabChapterFrame onExit={onExit} showLockup={false} data-id="element-912" data-mp="7ygmsxh45uad">
      <Reveal delay={0} data-id="element-913" data-mp="cuxajqkei6mx">
        <div className="flex items-end gap-[40px]" data-id="element-914" data-mp="cw8p8lfdwyst">
          <TalabLockup variant="hero" data-id="element-915" data-mp="22awqbqiiyubj" />
          <span className="h-[66px] w-px bg-slate-900/[0.10]" data-id="element-916" data-mp="22byb4mpcev6g" />
          <div className="pb-[2px]" data-id="element-917" data-mp="27a9mx2z77frb">
            <h2 className="text-[33px] font-semibold leading-[1.1] tracking-[-0.03em] text-slate-900" data-id="element-918" data-mp="278gbladn47cz">
              Your Store. Now Conversational.
            </h2>
            <p className="mt-[8px] max-w-[600px] text-[14.5px] font-light leading-[1.55] text-slate-500" data-id="element-919" data-mp="w5ws0u68on3h">
              A conversational commerce platform that gives businesses their own
              AI-powered storefront.
            </p>
          </div>
        </div>
      </Reveal>

      <div className="mt-[26px] flex gap-[24px]" data-id="element-920" data-mp="1a5fkyfqhbrv7">
        <div className="flex-1 space-y-[14px]" data-id="element-921" data-mp="1a5pda9yzyb42">
          <Reveal delay={0.1} data-id="element-922" data-mp="1f3z98msjpfqq">
            <StorefrontHero data-id="element-923" data-mp="1f37pc98b96ga" />
          </Reveal>
          <MerchantStrip data-id="element-924" data-mp="1f1wj82re7mm0" />
        </div>

        {/* Same engine, three touchpoints */}
        <Reveal delay={0.2} className="w-[430px]" data-id="element-925" data-mp="1092tzpmbjs45">
          <div className="flex h-full flex-col rounded-2xl border border-slate-900/[0.07] bg-white/70 p-[16px]" data-id="element-926" data-mp="155a0bjimn5mm">
            <div className="flex justify-center" data-id="element-927" data-mp="3kwfqvph9l3js">
              <span className="rounded-full border border-vexu/40 bg-white px-[16px] py-[8px] text-[10px] font-semibold uppercase tracking-[0.2em] text-slate-900 shadow-[0_10px_26px_-14px_rgba(0,200,83,0.55)]" data-id="element-928" data-mp="3pwagzqt7tp3s">
                One Talab Commerce Engine
              </span>
            </div>

            <div className="mt-[12px] space-y-[10px]" data-id="element-929" data-mp="231yi8mofctab">
              {CONTEXTS.map((context, index) => <motion.div key={context.name} initial={{
              opacity: 0,
              x: 10
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              duration: 0.3,
              ease: EASE,
              delay: 0.36 + index * 0.1
            }} className="flex items-center gap-[13px] rounded-xl border border-slate-900/[0.06] bg-white p-[10px]" data-id="element-930" data-mp="2cxs4wyvuy35t" data-mpi={index}>
                  <ContextMock index={index} data-id="element-931" data-mp="1t8hrxsnhxwbe" />
                  <div className="min-w-0" data-id="element-932" data-mp="15joprega6s8c">
                    <div className="flex items-center gap-[7px]" data-id="element-933" data-mp="15inbl13yxpme">
                      <context.icon className="h-[12px] w-[12px] text-vexu-600" data-id="element-934" data-mp="11jeky54867v2" />
                      <span className="text-[12.5px] font-semibold tracking-[-0.01em] text-slate-900" data-id="element-935" data-mp="30nwjeox6d9ji">
                        {context.name}
                      </span>
                    </div>
                    <p className="mt-[4px] text-[11px] font-light leading-[1.5] text-slate-500" data-id="element-936" data-mp="3adg502c9vhi2">
                      {context.detail}
                    </p>
                  </div>
                </motion.div>)}
            </div>

            <p className="mt-[12px] text-center text-[10.5px] font-semibold uppercase tracking-[0.18em] text-slate-400" data-id="element-937" data-mp="2hq21fle2jnoz">
              Same intelligence. Different touchpoints.
            </p>
          </div>
        </Reveal>
      </div>

      <div className="flex-1" data-id="element-938" data-mp="2wlrs3wu78p01" />

      <Reveal delay={1} data-id="element-939" data-mp="2wm1i3kf8uw5q">
        <div className="h-px w-full bg-slate-900/[0.10]" data-id="element-940" data-mp="2wncmnmgik7xw" />
        <div className="flex items-center justify-between pt-[20px]" data-id="element-941" data-mp="6wz87zdimwzd">
          <p className="text-[20px] font-light tracking-[-0.015em] text-slate-500" data-id="element-942" data-mp="6ysf9fs1jj7w">
            Your products. Your customers.{' '}
            <span className="font-medium text-slate-900" data-id="element-943" data-mp="1we343i6h4a06">
              Your conversational storefront.
            </span>
          </p>
          <span className="rounded-full border border-vexu/30 bg-vexu/[0.07] px-[12px] py-[5px] text-[9.5px] font-semibold uppercase tracking-[0.18em] text-vexu-700" data-id="element-944" data-mp="1rf09kro4dm6g">
            Powered by Vexu AI
          </span>
        </div>
      </Reveal>
    </TalabChapterFrame>;
}